<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="titlepage" epub:type="titlepage">
<p class="TPT"><span aria-label=" Page iv. " epub:type="pagebreak" id="pg_iv" role="doc-pagebreak"><samp><b>2 A.M. IN LITTLE AMERICA</b></samp></span></p>
<p class="TPST" role="doc-subtitle"><samp><b>a novel</b></samp></p>
<p class="TPAU"><samp><b>KEN KALFUS</b></samp></p>
<p class="TPL"><samp>MILKWEED EDITIONS</samp></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?0ef29e63